import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const ELASTICSEARCH_URL = environment.baseElasticSearchUrl;
const NOTIFICATION_API = environment.marketplaceNotificationsApi;

const PLATFORMENDPOINT = environment.platformEndpoint;

@Injectable({
  providedIn: 'root'
})

export class MarketService {

  private apiUrl = "https://tq04q5hwtf.execute-api.us-east-1.amazonaws.com/uat/properties";
  private spApiUrl = "https://tq04q5hwtf.execute-api.us-east-1.amazonaws.com/uat/sponsors";

  private elasticSearchUrl = ELASTICSEARCH_URL+"/market_place_index/"; 
  private elasticSponsorUrl = ELASTICSEARCH_URL+"/market_sponsor_index/";
  
  private createUserAPI = "https://5kf75bwfr8.execute-api.us-east-1.amazonaws.com/uat/cognito/users";
  private addToPropertiesGroupAPI = "https://5kf75bwfr8.execute-api.us-east-1.amazonaws.com/uat/cognito/properties-user";
  private addToSponsorsGroupAPI = "https://5kf75bwfr8.execute-api.us-east-1.amazonaws.com/uat/cognito/sponsors-user";
  private listCognitoUsersAPI = "https://5kf75bwfr8.execute-api.us-east-1.amazonaws.com/uat/cognito/list-users"; 

  private welcomeAPI = NOTIFICATION_API+"/welcome"; 
  private propertyConfirmationAPI = NOTIFICATION_API+"/confirm"; 

  private uploadAPI = "https://mhgxxa8260.execute-api.us-east-1.amazonaws.com/Stage/";  

  private sponsorshipApplicationAPI = "https://4q9hw4uzy0.execute-api.us-east-1.amazonaws.com/uat/sponsorship";
  private getSponsorshipApplicationsAPI =  "https://eh51w82ao9.execute-api.us-east-1.amazonaws.com/qa/sponsorship-properties"; 
  private getPropertiesPerOwnerIdAPI = "https://eh51w82ao9.execute-api.us-east-1.amazonaws.com/qa/sponsorship-properties-perId"; 
  private updateSponsorshipApplicationStatusAPI = "https://eh51w82ao9.execute-api.us-east-1.amazonaws.com/qa/update-application-status";
  private rejectApplicationAPI = "https://eh51w82ao9.execute-api.us-east-1.amazonaws.com/qa/reject-application-description"

  private propElasticSearchUrl = PLATFORMENDPOINT+"/properties/search";
  private propertiesAPI = PLATFORMENDPOINT+"/properties";

  constructor(private http: HttpClient) { }

  onSearch(searchWord: any) {
    let headers = this.createSimpleReqHeader();    //SimpleReqHeader
    return this.http.get<any>(this.elasticSearchUrl + "_search?q=" + searchWord, { headers: headers });
  }

  onApplyForSponsorship(body: any) {
    let headers = this.createRequestHeader();
    return this.http.post<any>(this.sponsorshipApplicationAPI, body, { headers: headers })
  }

  onListCognitoUsers(email: any) {
    let headers = this.createRequestHeader();
    return this.http.post<any>(this.listCognitoUsersAPI, email, { headers: headers })
  }

  onUploadToBucket(file: any) {
    let headers = this.createSimpleReqHeader();
    return this.http.post<any>(this.uploadAPI, file, { headers: headers });
  }

  onQuerySearch(body: any, pageName: any) {

    let headers = this.createSimpleReqHeader();    //SimpleReqHeader
    switch (pageName) {
      case "home":
        return this.http.post<any>(this.propElasticSearchUrl, body, { headers: headers });
      case "sponsors":
        return this.http.post<any>(this.elasticSponsorUrl + "_search?size=1000", body, { headers: headers });
    }
  }

  updateSponsorshipApplicationStatus(body: any) {
    let headers = this.createRequestHeader();
    return this.http.patch<any>(this.updateSponsorshipApplicationStatusAPI, body, { headers: headers });
  }

  rejectApplicationDescription(body: any) {
    let headers = this.createRequestHeader();
    return this.http.patch<any>(this.rejectApplicationAPI, body, { headers: headers });
  }

  addToPropertiesGroup(username: any) {
    let headers = this.createSimpleReqHeader();
    return this.http.post<any>(`${this.addToPropertiesGroupAPI}`, username, { headers: headers });
  }

  addToSponsorsGroup(username: any) {
    let headers = this.createRequestHeader();
    return this.http.post<any>(`${this.addToSponsorsGroupAPI}`, username, { headers: headers });
  }

  creatUser(body: any) {
    let headers = this.createRequestHeader();
    return this.http.post<any>(`${this.createUserAPI}`, body, { headers: headers });
  }

  addProperty(body: any) {
    let headers = this.createSimpleReqHeader();
    return this.http.post<any>(this.propertiesAPI, body, { headers: headers });
  }

  getPropertyById(propertyId: string){
    let header = this.createRequestHeader();

    return this.http.get<any>(this.propertiesAPI+"/"+propertyId, {headers: header});
  }

  addSponsor(body: any) {
    let headers = this.createRequestHeader();
    return this.http.post<any>(`${this.spApiUrl}`, body, { headers: headers })
  }

  getSponsors() {
    let headers = this.createSimpleReqHeader(); //SimpleReqheader
    return this.http.get<any>(this.spApiUrl, { headers: headers });
  }

  getSponsorshipApplications() {
    let headers = this.createRequestHeader();
    return this.http.get<any>(this.getSponsorshipApplicationsAPI, { headers: headers });
  }

  getPropertiesPerOwnerId(body: any) {
    let headers = this.createRequestHeader();
    return this.http.post<any>(this.getPropertiesPerOwnerIdAPI, body, { headers: headers });
  }

  getProperties(owner: any) {
    let headers = this.createSimpleReqHeader();    //SimpleReqHeader
    return this.http.get<any>(this.propertiesAPI + "?owner=" + owner, { headers: headers });
  }

  deleteProperty(propertyId: any){
    let headers = this.createSimpleReqHeader();

    return this.http.delete<any>(this.propertiesAPI+"/"+propertyId,  {headers: headers});
  }

  editProperty(property: any){
    let headers = this.createSimpleReqHeader();
    // return this.http.put<any>(this.property_api+"/"+property.propertyId, property, {headers: header});
    return this.http.put(`${this.propertiesAPI}/` + property.propertyId, property, {headers: headers});
  }

  getElasticProperties() {
    let headers = this.createSimpleReqHeader();    //SimpleReqHeader
    return this.http.get<any>(this.elasticSearchUrl + "_search?size=1000", { headers: headers });
  }

  sendWelcomeEmailRespondent(body: any) {
    let headers = this.createRequestHeader();
    return this.http.post<any>(this.welcomeAPI, body, { headers: headers });
  }

  sendWelcomePropertyEmail(body: any) {
    let headers = this.createRequestHeader();
    return this.http.post<any>(this.propertyConfirmationAPI, body, { headers: headers });
  }

  private createRequestHeader() {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Authorization', 'Basic ZWxhc3RpYzpVajhxenNIbGlKMXpkVm1IeE5EUXh2SzA=');
    return headers;
  }

  private createSimpleReqHeader() {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    return headers;
  }

  private propertyRequestHeader() {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return headers;
  }

  //testing build 
}